// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { AVLPOSITIONS_abstract } from './../../abstract/SagaBase/Objects/AVLPOSITIONS_abstract';
export class AVLPOSITIONS extends AVLPOSITIONS_abstract {}
